<p>Test page for creating account and logging in (sort of)</p>

<p>&nbsp;</p>
<p>&nbsp;</p>

<fieldset>
    <legend>Create Account</legend>
    <p>
        <label>Email</label><br/>
        <input type="text" [(ngModel)]="email" />
    </p>
    <p>
        <label>Password</label><br/>
        <input type="password" [(ngModel)]="password" />
    </p>
    <p>
        <label>First Name</label><br/>
        <input type="text" [(ngModel)]="firstName" />
    </p>
    <p>
        <label>Last Name</label><br/>
        <input type="text" [(ngModel)]="lastName" />
    </p>
    <p>
        <button class="btn" (click)="create()">Create Account</button>
        
    </p>
</fieldset>

<fieldset>
    <legend>Sign In</legend>
    <p>
        <label>Email</label><br/>
        <input type="text" [(ngModel)]="email" />
    </p>
    <p>
        <label>Password</label><br/>
        <input type="password" [(ngModel)]="password" />
    </p>
    <p>
        <button class="btn" (click)="signIn()">Sign In</button>
        
    </p>
</fieldset>
